import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { Advertiser } from '../../core/models/advertiser';
import { Agency } from '../../core/models/agency';

@Component({
  selector: 'app-portal',
  templateUrl: './portal.component.html',
  styleUrls: ['./portal.component.scss']
})
export class PortalComponent implements OnInit, OnDestroy {
  public advertisers: Array<Advertiser>;
  public agencies: Array<Agency>;

  public items: any = [];

  private subs: Array<Subscription> = [];

  constructor() {}

  ngOnInit() {}

  ngOnDestroy() {
    this.subs.forEach(sub => sub.unsubscribe());
  }
}
